//@flow

// Vendors
import React from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

// Components
import { Navbar, NavbarAccountDropdown, NavbarBranding } from '../..';

// Styles
import './navbar-auth.scss';

// Types
type Props = {
  mobileNav: Object,
};

const NavbarAuth = ({ mobileNav }: Props) => (
  <CSSTransition
    in={!mobileNav.isActive}
    classNames="navbar"
    timeout={!mobileNav.isActive ? 0 : 500}
    unmountOnExit
  >
    <Navbar className="navbar-auth">
      <div className="navbar-left">
        <NavbarBranding to="/" aria-label="View My Dashboard" />
      </div>
      <div className="navbar-right">
        <NavbarAccountDropdown />
      </div>
    </Navbar>
  </CSSTransition>
);

const mapStateToProps = ({ mobileNav }) => ({ mobileNav });

export default connect(mapStateToProps)(NavbarAuth);
